import axios from "axios"

const resetPassword = async (userData: {
    email: string
    userType: string
    otp: string
    password: string
}) => {
    try {
        const { data } = await axios.post(
            process.env.NEXT_PUBLIC_API_URL + "users/reset-password",
            userData
        )

        return data
    } catch (error: any) {
        return error.response.data
    }
}

export default resetPassword
